module.exports = "/_next/static/images/plane-line-473b8912adf6610bfc9f328b1a2f3c85.svg";